import FeatureGates from '@atlassian/feature-gate-js-client';
import AdminTrialCart, { ModulePropsV0 } from './admin-trial-cart';
import { useEffect } from 'react';
import Cookies from 'js-cookie';

const StatsigContainer = (props: ModulePropsV0) => (
  <FeatureGatedAdminTrialCart {...props} />
);

const NonEnrolledCart = () => {
  useEffect(() => {
    FeatureGates.manuallyLogExperimentExposure('wac_cart_a-b_experiment');
  }, []);

  return <></>;
};

const FeatureGatedAdminTrialCart = (props: ModulePropsV0) => {
  const aaid = Cookies.get('__aid_user_id');
  if (!aaid || aaid === '') {
    return <></>;
  }

  const enrolledAb = FeatureGates.getExperimentValue(
    'wac_cart_a-b_experiment',
    'treatment',
    'non-enrolled',
    { fireExperimentExposure: false }
  );

  if (enrolledAb === 'non-enrolled') {
    return <NonEnrolledCart />;
  }

  return <AdminTrialCart {...props} enrolled={enrolledAb} />;
};

export default StatsigContainer;
export { ModulePropsV0 } from './admin-trial-cart';
